<template>
  <div class="card accompagnement-card h-100 shadow-sm">
    <div class="card-img-top-wrapper">
      <img
        src="@/assets/img//photo/soins-palliatif.jpg"
        class="card-img-top"
        :alt="$t('accompPalliatifResume.image.alt')"
      />
    </div>
    <div class="card-body d-flex flex-column">
      <h5 class="fw-bold" style="font-size: 1.3rem">
        {{ $t("accompPalliatifResume.title") }}
      </h5>

      <p class="text-muted" style="font-size: 1rem; line-height: 1.4">
        {{ $t("accompPalliatifResume.text.p1") }}
        <br />
        {{ $t("accompPalliatifResume.text.p2") }}
      </p>

      <a
        href="/accompagnement-palliatif"
        class="btn btn-custom mt-2 w-100 mt-auto"
      >
        {{ $t("accompPalliatifResume.button.more") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccompPalliatifResume",
};
</script>

<style></style>
